const initialState = {
  contractsQS: [],
  servicesQS: [],
  assetsQS: [],
  keyword: "",
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    // case "camp/cleanCamp":
    //   return initialState;
    case "quickSearch/storeData":
      return action.payload;
    // case "camp/setLoading":
    //   return { ...state, loading: action.payload };
    default:
      return state;
  }
}
